import { IResource } from "@gettactic/api";

export const getLegacyVisibleAssignment = (
  totalResources: IResource[] | undefined,
  zoneId: string
) => {
  return (
    totalResources?.find((x) => x.id === zoneId && !!x.visible_assignment)
      ?.visible_assignment ?? null
  );
};

export const getVisibleAssignment = (
  totalResources: IResource[] | undefined,
  zoneId: string
) => {
  const resource = totalResources?.find((x) => x.id === zoneId);
  if (!resource) {
    return null;
  }

  const userVisibleAssignments = resource.user_visible_assignments;
  const teamVisibleAssignments = resource.team_visible_assignments;

  // this may happen from the old design
  if (!userVisibleAssignments || !teamVisibleAssignments) {
    return null;
  }

  if (
    userVisibleAssignments.length === 1 &&
    teamVisibleAssignments.length === 0
  ) {
    return userVisibleAssignments[0];
  }

  return null;
};
